import React from 'react'

const WhatsAppButton = () => {
  const phoneNumber = '917989308337'
  
  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
      aria-label="Contact us on WhatsApp"
    >
      <img src="/whatsapp-icon.png" alt="WhatsApp" className="w-14 h-14" />
    </a>
  )
}

export default WhatsAppButton

